import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-14",
  "use": "menu-14-usage",
  "viewBox": "0 0 116 116",
  "content": "<symbol viewBox=\"0 0 116 116\" id=\"menu-14\"><title>资源 114</title><g id=\"menu-14_图层_2\" data-name=\"图层 2\"><g id=\"menu-14_图层_1-2\" data-name=\"图层 1\"><path d=\"M58,42.76A15.24,15.24,0,1,0,73.24,58,15.26,15.26,0,0,0,58,42.76Z\" /><path d=\"M58,23.78A34.22,34.22,0,1,0,92.22,58,34.26,34.26,0,0,0,58,23.78Zm0,55.29A21.07,21.07,0,1,1,79.07,58,21.1,21.1,0,0,1,58,79.07Z\" /><path d=\"M58,0a58,58,0,1,0,58,58A58,58,0,0,0,58,0Zm51.55,61.48H99a41.17,41.17,0,0,1-82,0h-11a3.48,3.48,0,0,1,0-7H17a41.17,41.17,0,0,1,82,0h10.53a3.48,3.48,0,1,1,0,7Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-14.svg
// module id = g5FX
// module chunks = 264